import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Tabs from '@components/tabs/Tabs'

const TEST_DATA = [
  { label: 'Item 1', value: 1 },
  { label: 'Item 2', value: 2 },
  { label: 'Item 3', value: 3 },
  { label: 'Item 4', value: 4 },
]

const SegmentedControlsSection = () => {
  const [value1, setValue1] = React.useState(TEST_DATA[0])
  const [value2, setValue2] = React.useState(TEST_DATA[0])
  const [value3, setValue3] = React.useState(TEST_DATA[0])
  return (
    <Section>
      <SectionTitle>Tabs</SectionTitle>
      <Container>
        <Tabs data={TEST_DATA.slice(0, 2)} value={value2} onItemSelected={setValue2} />
      </Container>

      <Container>
        <Tabs data={TEST_DATA.slice(0, 3)} value={value3} onItemSelected={setValue3} />
      </Container>

      <Container>
        <Tabs data={TEST_DATA} value={value1} onItemSelected={setValue1} />
      </Container>

      <Container>
        <Tabs equalTabs={false} data={TEST_DATA} value={value1} onItemSelected={setValue1} />
      </Container>
    </Section>
  )
}

export default SegmentedControlsSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const Container = styled(View)`
  margin-bottom: 24px;
`
